<mat-card>
  <mat-card-title class="current-month__title">
    <button
      id="btn-expandCard"
      mat-button
      class="current-month__button-expand"
      (click)="onClickExpandButton()"
      disableRipple="true"
    >
      <mat-icon [class]="isOpened ? 'icon-ic_remove_circle_outline' : 'icon-ic_add_circle_outline'"></mat-icon>
    </button>
    <span>{{ title }}</span>
  </mat-card-title>
  <mat-card-content *ngIf="isOpened">
    <table
      mat-table
      aria-label="current-month"
      [dataSource]="dataSource"
      [ngClass]="
        division === 10
          ? 'current-month__table current-month__table--division-consumo'
          : 'current-month__table current-month__table--division-autos'
      "
    >
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="current-month__column-status">
          {{ 'activity.monthly.table.status' | translate | uppercase }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.state }}</td>
      </ng-container>
      <ng-container matColumnDef="cic">
        <th mat-header-cell *matHeaderCellDef class="current-month__column-cic">
          {{ 'activity.monthly.table.cic' | translate | uppercase }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.p10 }}</td>
      </ng-container>
      <ng-container matColumnDef="tjt">
        <th mat-header-cell *matHeaderCellDef class="current-month__column-tjt">
          {{ 'activity.monthly.table.tjt' | translate | uppercase }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.p30 }}</td>
      </ng-container>
      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef class="current-month__column-total">
          {{ 'activity.monthly.table.total' | translate | uppercase }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.total }}</td>
      </ng-container>
      <ng-container matColumnDef="finance">
        <th mat-header-cell *matHeaderCellDef class="current-month__column-finance">
          {{ 'activity.monthly.table.finance' | translate | uppercase }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.financed | transformNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="prot">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.prot' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.ppt }}</td>
      </ng-container>
      <ng-container matColumnDef="cia">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.cia' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.p20 }}</td>
      </ng-container>
      <ng-container matColumnDef="cip">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.cip' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.p15 }}</td>
      </ng-container>
      <ng-container matColumnDef="co">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.co' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.p30 }}</td>
      </ng-container>
      <ng-container matColumnDef="lc">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.lc' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.p40 }}</td>
      </ng-container>
      <ng-container matColumnDef="incTotal">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.incTotal' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.incAgent | transformNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="incVendor">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.incVendor' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.incSeller | transformNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="ppp">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.ppp' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.losses }}</td>
      </ng-container>
      <ng-container matColumnDef="ppb">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.ppb' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.ppb }}</td>
      </ng-container>
      <ng-container matColumnDef="ppt">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.ppt' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.ppt }}</td>
      </ng-container>
      <ng-container matColumnDef="protection">
        <th mat-header-cell *matHeaderCellDef>{{ 'activity.monthly.table.protection' | translate | uppercase }}</th>
        <td mat-cell *matCellDef="let element">{{ element.incProtections | transformNumber }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card-content>
</mat-card>
